import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./store/reducers";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import PiwikPro from "@piwikpro/react-piwik-pro";

PiwikPro.initialize(
  "f2576cca-8aba-492f-a169-df589f940d98",
  "https://whatwatch.containers.piwik.pro"
);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
